import { render, staticRenderFns } from "./AiAssistant.vue?vue&type=template&id=6e390267&scoped=true"
import script from "./AiAssistant.vue?vue&type=script&lang=js"
export * from "./AiAssistant.vue?vue&type=script&lang=js"
import style0 from "./AiAssistant.vue?vue&type=style&index=0&id=6e390267&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e390267",
  null
  
)

export default component.exports